import { render } from "./AreasView.vue?vue&type=template&id=30464a3b&scoped=true"
import script from "./AreasView.vue?vue&type=script&lang=js"
export * from "./AreasView.vue?vue&type=script&lang=js"

import "./AreasView.vue?vue&type=style&index=0&id=30464a3b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30464a3b"]])

export default __exports__